import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const starburst = Array.from({
  length: 48
}).map((_, i) => {
  const angle = Math.PI * 2 * i / 48;
  const r = i % 2 === 0 ? 50 : 45;
  return `${50 + r * Math.cos(angle)}% ${50 + r * Math.sin(angle)}%`;
}).join(', ');
const guaranteeCopy = {
  eyebrow: 'Tu compra está protegida',
  title: 'Tenés 7 días de garantía para comprar con tranquilidad.',
  lead: 'Queremos que disfrutes de Baby Shower Dulce Recuerdo con tranquilidad.',
  body: 'Si el material no cumple con tus expectativas, podés solicitar la devolución de tu dinero dentro de los 7 días posteriores a la compra.',
  footer: 'Compra segura · Garantía de satisfacción',
  legal: 'Esta garantía comercial no limita los derechos que correspondan al consumidor por ley.'
};
export function GuaranteeSeal() {
  return <section aria-labelledby="guarantee-title" className="bg-[#FAF0E7] py-11 md:py-16" data-id="element-136" data-mp="3khhxhjmmzidy">
      <div className="mx-auto max-w-xl px-6 text-center" data-id="element-137" data-mp="3gg67hczuov58">
        <div className="mx-auto flex h-36 w-36 items-center justify-center bg-[#F5B4C9] md:h-44 md:w-44" style={{
        clipPath: `polygon(${starburst})`
      }} role="img" aria-label="Sello de garantía de 7 días" data-id="element-138" data-mp="32ncyvxv9hhjc">
          <div className="flex h-[80%] w-[80%] items-center justify-center rounded-full bg-[#93D1CE] p-1" data-id="element-139" data-mp="3bnjblhj4ydhg">
            <div className="flex h-full w-full flex-col items-center justify-center rounded-full bg-white text-[#4A3A35]" data-id="element-140" data-mp="3gne0jfjcoszv">
              <ShieldCheckIcon className="h-4 w-4 text-[#E74D7A] md:h-5 md:w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-141" data-mp="2jy6gyd2aktyl" />
              <span className="mt-0.5 font-display text-[10px] font-extrabold uppercase tracking-[0.16em] text-[#8B6B55] md:text-[11px]" data-id="element-142" data-mp="2nyqdpfiydvk7">
                Garantía
              </span>
              <span className="font-display text-[2.5rem] font-extrabold leading-none md:text-5xl" data-id="element-143" data-mp="2xpun7zpv0o7n">7</span>
              <span className="font-display text-[11px] font-extrabold uppercase tracking-[0.18em] md:text-[13px]" data-id="element-144" data-mp="208m7r1ialjq1">Días</span>
            </div>
          </div>
        </div>

        <p className="mt-6 inline-flex max-w-full items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-145" data-mp="38huuffu1u464">
          {guaranteeCopy.eyebrow}
        </p>
        <h2 id="guarantee-title" className="mx-auto mt-4 max-w-[24ch] font-display text-[1.5rem] font-extrabold leading-[1.2] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[1.9rem]" data-id="element-146" data-mp="3d9l89vs73a2a">
          {guaranteeCopy.title}
        </h2>
        <div className="mx-auto mt-4 max-w-md space-y-3 text-[16px] leading-relaxed text-body md:text-[17px]" data-id="element-147" data-mp="2klz4oniyw5ff">
          
          <p className="font-semibold text-[#4A3A35]" data-id="element-148" data-mp="2ym9udn8jjdz0">{guaranteeCopy.body}</p>
        </div>

        <p className="mt-5 text-[14px] font-semibold text-[#8B6B55]" data-id="element-149" data-mp="2tk2g2r08nlti">{guaranteeCopy.footer}</p>
        
      </div>
    </section>;
}